import { render, staticRenderFns } from "./MainDetailForReview.vue?vue&type=template&id=55048c6d&scoped=true&"
import script from "./MainDetailForReview.vue?vue&type=script&lang=js&"
export * from "./MainDetailForReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55048c6d",
  null
  
)

export default component.exports